"use client";
import r, { Component as o } from "react";
class n extends o {
  constructor() {
    super(...arguments), this.state = {
      errorMessage: ""
    }, this.logErrorToServices = console.log;
  }
  static getDerivedStateFromError(e) {
    return { errorMessage: e.toString() };
  }
  componentDidCatch(e, t) {
    this.logErrorToServices(e.toString(), t.componentStack);
  }
  render() {
    return this.state.errorMessage ? /* @__PURE__ */ r.createElement("p", null, this.state.errorMessage) : /* @__PURE__ */ r.createElement(r.Fragment, null, this.props.children);
  }
}
export {
  n as default
};
//# sourceMappingURL=index.es41.js.map
